const types = {
  TOGGLE_MOBILE_FACET: 'app/mobile/TOGGLE_MOBILE_FACET',
  SET_MOBILE_FACET: 'app/mobile/SET_MOBILE_FACET',
};

export default types;
